import { render, staticRenderFns } from "./draggableContainer.vue?vue&type=template&id=46c06f9d"
import script from "./draggableContainer.vue?vue&type=script&lang=js"
export * from "./draggableContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports